module.exports = __webpack_public_path__ + "img/destination_stonetown_ln.81c5210f.jpg";